import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Col, Form, Spinner } from 'react-bootstrap';
import { completeInvitedPasswordSetup } from '../../features/auth/authSlice';
import ParticlesAuth from './ParticlesAuth';

const InvitedPasswordSetup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, mustChangePassword, token, status } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    password: '',
    password_confirmation: '',
  });
  const [error, setError] = useState('');

  const loading = status === 'loading';
  const hasToken = Boolean(token || localStorage.getItem('auth_token'));

  if (!hasToken) {
    return <Navigate to="/login" replace />;
  }

  if (!mustChangePassword && localStorage.getItem('auth_must_change_password') !== 'true') {
    return <Navigate to="/dashboard" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (formData.password !== formData.password_confirmation) {
      setError('Password confirmation does not match.');
      return;
    }

    try {
      await dispatch(completeInvitedPasswordSetup(formData)).unwrap();
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err || 'Could not update password.');
    }
  };

  return (
    <ParticlesAuth>
      <Col xxl={6} className="mx-auto">
        <Card className="mb-0 border-0 shadow-none">
          <Card.Body className="p-sm-5">
            <div className="text-center mt-4">
              <h5 className="fs-3xl">Set your new password</h5>
              <p className="text-muted">
                {user?.email ? `Welcome ${user.email}.` : 'Welcome.'} You must change your temporary password to continue.
              </p>
            </div>

            <Form onSubmit={onSubmit} className="mt-4">
              {error && <Alert variant="danger">{error}</Alert>}

              <Form.Group className="mb-3">
                <Form.Label>New password</Form.Label>
                <Form.Control
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData((prev) => ({ ...prev, password: e.target.value }))}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Confirm new password</Form.Label>
                <Form.Control
                  type="password"
                  value={formData.password_confirmation}
                  onChange={(e) => setFormData((prev) => ({ ...prev, password_confirmation: e.target.value }))}
                  required
                />
              </Form.Group>

              <Button type="submit" className="w-100" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner size="sm" animation="border" className="me-2" />
                    Updating...
                  </>
                ) : (
                  'Update password'
                )}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </ParticlesAuth>
  );
};

export default InvitedPasswordSetup;
